import {createSlice,PayloadAction} from '@reduxjs/toolkit';

interface UIState { sidebarCollapsed: boolean; notifications: any[]; unreadCount: number; currentPage: string; }

const uiSlice = createSlice({
  name: 'ui',
  initialState: { sidebarCollapsed: false, notifications: [], unreadCount: 0, currentPage: '' } as UIState,
  reducers: {
    toggleSidebar(state) { state.sidebarCollapsed = !state.sidebarCollapsed; },
    setSidebarCollapsed(state, a: PayloadAction<boolean>) { state.sidebarCollapsed = a.payload; },
    setNotifications(state, a: PayloadAction<any[]>) { state.notifications = a.payload; },
    setUnreadCount(state, a: PayloadAction<number>) { state.unreadCount = a.payload; },
    addNotification(state, a: PayloadAction<any>) { state.notifications.unshift(a.payload); state.unreadCount += 1; },
    setCurrentPage(state, a: PayloadAction<string>) { state.currentPage = a.payload; },
  },
});

export const {toggleSidebar,setSidebarCollapsed,setNotifications,setUnreadCount,addNotification,setCurrentPage} = uiSlice.actions;
export default uiSlice.reducer;
